import { useEffect, useState } from 'react'
import { useCurrentPractice } from 'contexts/PracticeContext'
import { getAnnouncementsForClinics, ClinicAnnouncement } from 'apis/contentful'

export const useAnnouncementBanner = (): ClinicAnnouncement | null => {
	const { currentUserConsolidator } = useCurrentPractice()
	const [announcement, setAnnouncement] = useState<ClinicAnnouncement | null>(null)

	useEffect(() => {
		if (!currentUserConsolidator?.id) return

		const fetch = async () => {
			try {
				const entries = await getAnnouncementsForClinics()
				const match = entries.find(
					(entry) => entry.enabled && entry.consolidatorIds?.includes(currentUserConsolidator.id)
				)
				setAnnouncement(match ?? null)
			} catch (err) {
				console.error('Failed to fetch announcement banner', err)
				setAnnouncement(null)
			}
		}

		fetch()
	}, [currentUserConsolidator?.id])

	return announcement
}
